export const stripNonDigits = (inputString: string): string => {
  return inputString.replace(/\D/g, '')
}

export const preformatPhoneNumber = (inputString: string): string => {
  // removes country code from value
  return stripNonDigits(inputString).slice(1)
}

export const formatPhoneNumberWithMask = (event: any) => {
  //console.log("formatPhoneNumber -> ", event?.target?.value);
  // strip out anything that isn't a digit
  let rawNumber = event.target.value.replace(/[^0-9]/g, '')

  // ignore the "1" from "+1"
  if (rawNumber.charAt(0) === '1') {
    rawNumber = rawNumber.slice(1)
  }

  //now format according to partern (XXX) XXX-XXXX
  const areaCode = rawNumber.substring(0, 3)
  const prefix = rawNumber.substring(3, 6)
  const lineNumber = rawNumber.substring(6, 10)

  let formattedNumber = ''
  if (rawNumber.length > 0) {
    if (prefix) {
      if (lineNumber) {
        // we have areaCode, prefix, and lineNumber
        formattedNumber = `+1 (${areaCode}) ${prefix}-${lineNumber}`
      } else {
        // we have areaCode and prefix
        formattedNumber = `+1 (${areaCode}) ${prefix}`
      }
    } else {
      // we have areaCode
      formattedNumber = `+1 (${areaCode}`
    }
  }

  event.target.value = formattedNumber
}

export function testUSPhoneNumber(value?: string): boolean {
  return Boolean(value) && Boolean(value?.match(/^\+1 \(\d{3}\) \d{3}-\d{4}$/))
}

// Format phone number for UI
export function formatPhoneNumber(input?: string): string {
  if (!input) return ''

  // Remove all non-digit characters
  let digits = input.replace(/\D/g, '')

  if (!digits.startsWith('1')) {
    digits = `1${digits}`
  }

  const country = digits[0]
  const area = digits.slice(1, 4)
  const central = digits.slice(4, 7)
  const line = digits.slice(7, 11)

  return `+${country} (${area}) ${central}-${line}`
}
